<template>
  <div>
    <h1>{{ headline }}</h1>
  </div>
</template>

<script>
export default {
  props: {
    headline: {
      type   : String,
      default: '',
    },
  },
}
</script>
